
// All rules to validate a field

import * as ErrorMessages from './ErrorMessages.js';

export const required = (text) => {
  if (text) {
    return null;
  } else {
    return ErrorMessages.isRequired;
  }
};

export const mustMatch = (field, fieldName) => {
  return (text, state) => {
    return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
  };
};

export const requiredWithSelection = (field, selection) => {
  return (text, state) => {
    if (state[field] === selection) {
      return required(text);
    }
  };
};

export const minLength = (length) => {
  return (text) => {
    return text.length >= length ? null : ErrorMessages.minLength(length);
  };
};

export const eqLength = (length) => {
  return (text) => {
    return text.length === length ? null : ErrorMessages.eqLength(length);
  };
};

export const regexMatch = (regex, message) => {
  return (text) => {
    return text.match(regex) ? null : ErrorMessages.regexMatch(message);
  };
};

export const emptyRegexMatch = (regex, message) => {
  return (text) => {
    return (text != null && text.match(regex)) || text == null || text == "" ? null : ErrorMessages.regexMatch(message);
  };
};

export const selectedNegativeNumber = (selected) => {
  if (selected > 0) {
    return null;
  } else {
    return ErrorMessages.isRequired;
  }
};



// WEBPACK FOOTER //
// ./src/components/Validation/Rules.js